<style lang="sass">

    @import ../../common/styles/settings
    @import ../../common/styles/mixins

    .page--change
        ul
            list-style-type: none
            padding: 0

        &__informations
            margin-bottom: $baseline*2
        &__information
            display: flex
            align-items: flex-start
            padding: $baseline*2 0
            border-bottom: 1px solid $color-border
            text-align: left
            +media('<small')
                flex-direction: column
                align-items: center

            &__content
                max-width: 32em
                +media('<small')
                    text-align: center

            .title
                margin-bottom: $baseline
                +media('<small')
                    font-size: 1.375rem

            img
                height: $baseline*3
                margin-left: auto
                margin-right: auto
                +media('<small')
                    margin-bottom: $baseline
                +media('>=medium')
                    width: 10.25%
                    height: auto
                    margin-left: 8.25%
                    margin-right: 1.25rem

        &__image
            background-color: $color-accent
            min-height: $baseline*8
            +media('>=small')
                min-height: $baseline*21

            img
                display: block
                width: 100%
                min-width: 100%

        &__steps
            justify-content: center

            + .card--tip
                +media('>=small')
                    margin-left: auto
                    margin-right: auto
                    max-width: 50%

        &__step
            display: flex
            margin-bottom: $baseline

            @for $i from 1 through 4
                $inc: $i - 1
                &:nth-child(#{$i}) .card__body
                    //background-color: hsl(44 - (3*$inc), 90 + (3*$inc), 49 - $inc)
                    background-color: $color-accent

        &__helps
            margin-top: $baseline
            margin-bottom: $baseline*2

        &__help
            display: flex
            align-items: stretch

            .card__cover
                width: 36%
                min-height: 100%
                background-size: cover
                background-position: center center

                +media('<small')
                    display: none

</style>

<script>
import Tabset from '../../common/components/tabset/Tabset.vue'
import Tab    from '../../common/components/tabset/Tab.vue'

export default {
  components: {
    Tabset,
    Tab
  },

}
</script>
